module.exports = "/images/vendor/flag-icon-css/flags/4x3/tm.svg?b13d1440e1d8f4c55361656fd3191952";